<template>
    <div id="balanceRecharge">
        <div class="balanceRecharge-top">
            <div class="info-grid">
                <div class="info-item">
                    <span class="info-label">名称：</span>
                    <span class="info-value">{{ nickname }}</span>
                </div>
                <div class="info-item">
                    <span class="info-label">当前时间：</span>
                    <span class="info-value">{{ toDay }}</span>
                </div>
                <div class="info-item">
                    <span class="info-label">刷单总金额：</span>
                    <span class="info-value">{{ totalPrice }} </span>
                </div>
                <div class="info-item">
                    <span class="info-label">刷单总笔数：</span>
                    <span class="info-value">{{ totalNum }} </span>
                </div>
                <div class="info-item">
                    <span class="info-label">今日刷单金额：</span>
                    <span class="info-value">{{ totalDayPrice }} </span>
                </div>
                <div class="info-item">
                    <span class="info-label">今日刷单笔数：</span>
                    <span class="info-value">{{ totalDayNum }} </span>
                </div>
            </div>
        </div>

        <div class="balanceRecharge-middle">
            <h1>充值金额</h1>
            <div class="package-choose">
                <div class="package-choose-item" v-for="(item, index) in packageChoose" :key="index"
                    :class="{ 'package-item-action': currentItem === index }" @click="changeState(index, item[0], item[1])">
                    <h1>{{ item[0] }}元</h1>
                    <!-- <p>佣金{{ item[1] }}元</p> -->
                </div>
            </div>
            <h1>支付备注</h1>
            <van-field v-model="remark" clearable label="" placeholder="请输入备注（选填）" />
        </div>
        <div class="balanceRecharge-action-btn">
            <button @click="toRecharge()">充 值</button>
        </div>

    </div>
</template>
<script>
import { wxRequest } from '@/api/user.js'

import Checkstand from "@/components/Checkstand";
import { Toast, Dialog } from 'vant';
export default {
    components: {
        Checkstand,
    },
    data() {
        return {
            toDay: '',
            totalNum: '',
            totalDayNum: '',
            totalPrice: '',
            totalDayPrice: '',

            recordLoginText: localStorage.getItem('recordLoginText'),
            iccid: '',
            packageChoose: [],

            //当前余额套餐
            currentItem: 0,
            price: 0,
            giftBalance: 0,

            //自定义金额
            popup: false,

            //自定义键盘
            showKeyboard: false,
            definedPrice: '',

            //收银台
            dataToPay: {},
            checkstandStyle: {
                height: '50%',
                transition: '0.8s !important',
            },

            //设置密码
            type: '',
            showPasswordPanel: false,
            password: '',
            confirmPassword: "",
            passwordKeyboard: false,
            confirmPasswordKeyboard: false,
            passwordPanelTop: 50,
            alreadySetUp: false,

            tuiPrice: 0,
            userAccount: {
                amount: 0,
            },
            mobile: '',
            code: '',
            openId: '',
            nickname: '',
            remark: '',
            payTotalAmount: '0',
        }
    },
    methods: {

        changeState(currentItem, price, giftBalance) {
            this.currentItem = currentItem;
            this.price = price;
            this.giftBalance = (giftBalance - price) * 100;
        },
        toRecharge() {
            var data = {
                openId: this.openId,
                amount: this.price,
                nickname: this.nickname,
                remark: this.remark
            }
            wxRequest("sim/other/pay", data, "post").then(res => {
                if (res.data.code == 200) {
                    window.location.href = res.data.data;
                } else {
                    Toast.fail(res.data.message);
                }
            })
        },
        async toSelectInfo() {

        }

    },
    async created() {
        //查询本地有没有缓存的OPENDI
        var payOtherOpenId = localStorage.getItem('payOtherOpenId');
        var payOtherNickname = localStorage.getItem('payOtherNickname');

        // 获取当前日期并格式化
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需+1，不足2位补0
        const day = String(date.getDate()).padStart(2, '0'); // 日期不足2位补0
        this.toDay = `${year}-${month}-${day}`;

        if (!(payOtherOpenId && payOtherOpenId.length > 5)) {
            var source = "wx18b33905435d410b";
            localStorage.setItem("appid", source);
            var redirectUrl = window.location.href;
            var index = redirectUrl.indexOf("code");
            redirectUrl = encodeURIComponent(redirectUrl);
            if (index < 0) {
                window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxb4bff16244869bed&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
            } else {
                var search = window.location.search;
                console.log("search", search);
                var startIndex = search.indexOf("code");
                var endIndex = search.indexOf("&", startIndex);
                var str = search.slice(startIndex, endIndex);
                var code = str.slice(str.indexOf("=") + 1);
                this.code = code;
                console.log(code);
                await wxRequest("sim/get/openId", { code: code }, "post").then(res => {
                    if (res.data.code == 200) {
                        this.openId = res.data.data.openId;
                        this.nickname = res.data.data.nickname;
                        localStorage.setItem('payOtherOpenId', this.openId);
                        localStorage.setItem('payOtherNickname', this.nickname);
                        this.iccid = '8888883338883888888';
                        wxRequest("sim/uniorder/param", { iccid: this.iccid }, "post").then(res => {
                            if (res.data.code == 200) {
                                for (let i = 0; i < res.data.data.length; i++) {
                                    let itme = [res.data.data[i].amount, res.data.data[i].giftBalance];
                                    this.packageChoose.push(itme);
                                }
                                this.price = this.packageChoose[0][0];
                                this.giftBalance = (this.packageChoose[0][1] - this.packageChoose[0][0]) * 100;
                            } else {
                                Toast.fail(res.data.message);
                            }
                        })
                        // 获取余额
                        wxRequest("sim/selectAmount/other", { openId: this.openId }, "post").then(res => {
                            if (res.data.code == 200) {
                                this.totalDayNum = res.data.data.totalDayNum;
                                this.totalDayPrice = res.data.data.totalDayPrice;
                                this.totalNum = res.data.data.totalNum;
                                this.totalPrice = res.data.data.totalPrice;
                            } else {
                                Toast.fail(res.data.message);
                            }
                        })
                    } else {
                        Toast.fail(res.data.message);
                        return;
                    }
                })
            }
        } else {
            this.openId = payOtherOpenId;
            this.nickname = payOtherNickname;
            this.iccid = '8888883338883888888';
            wxRequest("sim/uniorder/param", { iccid: this.iccid }, "post").then(res => {
                if (res.data.code == 200) {
                    for (let i = 0; i < res.data.data.length; i++) {
                        let itme = [res.data.data[i].amount, res.data.data[i].giftBalance];
                        this.packageChoose.push(itme);
                    }
                    this.price = this.packageChoose[0][0];
                    this.giftBalance = (this.packageChoose[0][1] - this.packageChoose[0][0]) * 100;
                } else {
                    Toast.fail(res.data.message);
                }
            })
            // 获取余额
            wxRequest("sim/selectAmount/other", { openId: this.openId }, "post").then(res => {
                if (res.data.code == 200) {
                    this.totalDayNum = res.data.data.totalDayNum;
                    this.totalDayPrice = res.data.data.totalDayPrice;
                    this.totalNum = res.data.data.totalNum;
                    this.totalPrice = res.data.data.totalPrice;
                } else {
                    Toast.fail(res.data.message);
                }
            })
        }

        // this.iccid = '8888883338883888888';
        // await wxRequest("sim/uniorder/param", { iccid: this.iccid }, "post").then(res => {
        //     if (res.data.code == 200) {
        //         for (let i = 0; i < res.data.data.length; i++) {
        //             let itme = [res.data.data[i].amount, res.data.data[i].giftBalance];
        //             this.packageChoose.push(itme);
        //         }
        //         this.price = this.packageChoose[0][0];
        //         this.giftBalance = (this.packageChoose[0][1] - this.packageChoose[0][0]) * 100;
        //     } else {
        //         Toast.fail(res.data.message);
        //     }
        // })


    },

    mounted() {
    },

    beforeDestory() {

    }
}
</script>
<style scoped lang="less">
#balanceRecharge .checkstand-defined-popup .van-field__control {
    font-size: 24px;
}

#balanceRecharge .checkstand-defined-popup input::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    font-size: 14px;
}

#balanceRecharge .checkstand-defined-popup input::-moz-placeholder {
    /* Firefox 19+ */
    font-size: 14px;
}

#balanceRecharge .checkstand-defined-popup input::-ms-input-placeholder {
    /* IE 10+ */
    font-size: 14px;
}

#balanceRecharge .checkstand-defined-popup input::-moz-placeholder {
    /* Firefox 18- */
    font-size: 14px;
}

#balanceRecharge .passwordInput .van-field__control {
    height: 24px;
}

.changePasswordPanel-balanceRecharge [class*=van-hairline]::after {
    border-color: #c4cedc;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

#balanceRecharge {
    background: #fff;
    height: 100%;

    .balanceRecharge-top {
        min-height: 160px;
        margin: 10px;
        padding: 15px;
        width: calc(100% - 20px);
        background: url('../../assets/top.png') no-repeat;
        background-size: 100% 100%;
        border-radius: 8px;
        /* 增加圆角更美观 */

        .info-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            /* 2列布局 */
            gap: 12px 10px;
            /* 行列间距 */
        }

        .info-item {
            display: flex;
            flex-direction: column;
            /* 标签和值上下排列 */
            line-height: 1.4;
        }

        .info-label {
            font-size: 13px;
            color: rgba(255, 255, 255, 0.9);
            /* 半透明白色标签 */
        }

        .info-value {
            font-size: 16px;
            font-weight: bold;
            color: #ffffff;
            text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
        }

        .alreadySetUp {
            width: 100%;
            text-align: center;
            height: 100%;
            color: #fff;

            p {
                font-size: 14px;
                line-height: 24px;
            }

            div {
                font-size: 26px;
                margin-top: 6px;
            }
        }
    }

    .balanceRecharge-middle {
        padding: 10px 20px 10px 20px;
        background: #fff;

        h1 {
            font-weight: bold;
            line-height: 30px;
            margin-bottom: 10px;
        }

        .package-choose {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            text-align: center;
        }

        .package-choose-item {
            height: 60px;
            margin-bottom: 20px;
            flex-basis: 30%;
            border-radius: 5px;
            border: 1px solid rgba(255, 169, 65, 1);
            color: #FFA941;

            h1 {
                font-weight: 400;
                font-size: 24px;
                line-height: 40px;
                margin: 0;
            }
        }

        .package-item-action {
            color: #fff;
            background: rgba(255, 169, 65, 1);
        }

        .package-choose-item-defined {
            h1 {
                font-size: 20px;
                line-height: 60px;
            }
        }
    }


    .balanceRecharge-action-btn {
        padding: 20px 20px 10px 20px;
        color: #fff;

        button {
            width: 100%;
            line-height: 36px;
            border-radius: 5px;
            font-size: 18px;
            background: rgba(255, 169, 65, 1);
            border: 0px solid rgba(255, 255, 255, 1);
        }
    }

    .balanceRecharge-tip {
        padding: 10px 20px 10px 20px;

        p {
            span {
                color: #FFA941;
            }

            line-height: 20px;
        }
    }

    .checkstand-defined {
        .checkstand-defined-popup {
            position: fixed;
            background-color: #fff;
            z-index: 92;
            width: 80%;
            min-height: 30%;
            top: 30%;
            left: 10%;
            border-radius: 15px;

            .input-defined {
                padding: 15px 0 0 30px;
                border-bottom: 1px solid #ccc;
                display: flex;

                span {
                    display: inline-block;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 47px;
                }
            }

            .btn-defined {
                padding: 30px 15px 20px 15px;

                button {
                    background: rgba(255, 169, 65, 1);
                    border: 0px solid rgba(255, 255, 255, 1);
                    width: 100%;
                    height: 36px;
                    font-size: 18px;
                    color: #fff;
                    border-radius: 5px;
                }
            }
        }

        .close-icon {
            position: absolute;
            right: 5px;
            top: -15px;
        }

        h1 {
            margin-top: 5px;
            font-size: 14px;
            line-height: 40px;
            text-align: center;
        }
    }
}

.changePasswordPanel-balanceRecharge {
    padding: 10px;

    .icon-cross {
        position: absolute;
        right: 10px;
        font-size: 16px;
    }

    p {
        margin: 10px 16px 0 16px;
        line-height: 30px;
    }

    .confirmChangePassword {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;

        .confirmChangePasswordBtn {
            width: 80px;
            margin: 0 15px;
        }
    }


}
</style>


